import { create } from 'zustand'

type MobileActiveTab = 'listings' | 'reviews' | 'portfolio' | 'activity'

interface MobileActiveTabStore {
  activeTab: MobileActiveTab
  setActiveTab: (tab: MobileActiveTab) => void
}

export const useMobileActiveTabStore = create<MobileActiveTabStore>((set) => ({
  activeTab: 'reviews',
  setActiveTab: (tab) => set({ activeTab: tab }),
}))
